import { datadogRum } from '@datadog/browser-rum';
import { getEnvironmentId } from './utils/getEnvironmentId';

function startRumRecording() {
    return window.location.search.includes('hjDebugSession=1');
}

function getSampleRate({ environmentId, isRecording }) {
    if (isRecording) {
        return 100;
    }

    return environmentId === 'live' ? 5 : 100;
}

const environmentId = getEnvironmentId();
const isRecording = startRumRecording();

if (environmentId !== 'dev') {
    const clientToken = 'pub9dd2d53aedc0e75487200c45ada37190',
        applicationId = '4736f14b-19f2-439c-b435-602757312b46',
        serviceName = 'insights';

    datadogRum.init({
        applicationId: applicationId,
        clientToken: clientToken,
        site: 'datadoghq.eu',
        service: serviceName,
        env: environmentId,
        sampleRate: getSampleRate({ environmentId, isRecording }),
        allowedTracingOrigins: [/https:\/\/.*\.hotjar\.com/, /https:\/\/.*\.hotjar\.io/]
    });

    if (isRecording) {
        datadogRum.startSessionReplayRecording();
    }
}

// Why are we attaching this datadogRum to window object 🤔
// We're initializing datadogRum in a separate Webpack entry than the rest of the app.
// To be able to call properly datadogRum we need to use the same instance from
//  the same Webpack entry
window.datadogRum = datadogRum;
